import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PIPELINE_STAGE_LABELS } from "../../../../constants/automapFoundingDealerConstants";
import {
  convertFoundingPipelineRecord,
  createFoundingProspect,
  fetchFoundingPipeline,
  updateFoundingPipelineRecord,
} from "../../../../services/automapFoundingDealerApi";
import { FoundingShell } from "./AdminFoundingShared";

export default function AdminFoundingPipelinePage() {
  const [view, setView] = useState("table");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    businessName: "",
    city: "Medellín",
    contactName: "",
    contactWhatsapp: "",
    source: "founder_outreach",
    priority: "medium",
  });

  const load = () => {
    setLoading(true);
    fetchFoundingPipeline()
      .then((data) => setRecords(data.records || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const createProspect = async () => {
    await createFoundingProspect(form);
    setForm({ businessName: "", city: "Medellín", contactName: "", contactWhatsapp: "", source: "founder_outreach", priority: "medium" });
    load();
  };

  const changeStage = async (recordId, pipelineStage) => {
    await updateFoundingPipelineRecord(recordId, { pipelineStage });
    load();
  };

  const convert = async (recordId) => {
    await convertFoundingPipelineRecord(recordId);
    load();
  };

  const boardColumns = [
    "prospect",
    "contacted",
    "interested",
    "demo_scheduled",
    "onboarding_started",
    "inventory_received",
    "inventory_cleaning",
    "verification_pending",
    "launch_ready",
    "active",
    "blocked",
    "not_interested",
  ];

  return (
    <FoundingShell active="pipeline" title="Pipeline fundadores" description="Prospecto → activo para el cohorte inicial.">
      <div className="dealer-inventory-toolbar">
        <button type="button" className={view === "table" ? "dealer-portal-btn" : "admin-btn admin-btn--secondary"} onClick={() => setView("table")}>
          Tabla
        </button>
        <button type="button" className={view === "board" ? "dealer-portal-btn" : "admin-btn admin-btn--secondary"} onClick={() => setView("board")}>
          Board
        </button>
      </div>
      <section className="dealer-state-box">
        <h3>Nuevo prospecto</h3>
        <div style={{ display: "grid", gap: "0.5rem", maxWidth: 480 }}>
          <input placeholder="Nombre comercial" value={form.businessName} onChange={(e) => setForm({ ...form, businessName: e.target.value })} />
          <input placeholder="Ciudad" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
          <input placeholder="Contacto" value={form.contactName} onChange={(e) => setForm({ ...form, contactName: e.target.value })} />
          <input placeholder="WhatsApp" value={form.contactWhatsapp} onChange={(e) => setForm({ ...form, contactWhatsapp: e.target.value })} />
          <button type="button" className="dealer-portal-btn" onClick={createProspect} disabled={!form.businessName.trim()}>
            Crear prospecto
          </button>
        </div>
      </section>
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && view === "table" ? (
        <section className="dealer-state-box">
          <table className="dealer-inventory-table">
            <thead>
              <tr>
                <th>Dealer</th>
                <th>Ciudad</th>
                <th>Etapa</th>
                <th>Prioridad</th>
                <th>Activos</th>
                <th>Readiness</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {records.map((row) => (
                <tr key={row.id}>
                  <td>{row.businessName}</td>
                  <td>{row.city || "—"}</td>
                  <td>{PIPELINE_STAGE_LABELS[row.pipelineStage] || row.pipelineStage}</td>
                  <td>{row.priority}</td>
                  <td>{row.actualActiveListingCount ?? 0}</td>
                  <td>{row.readinessScore ?? "—"}</td>
                  <td>
                    {!row.dealerId ? (
                      <button type="button" className="admin-link" onClick={() => convert(row.id)}>
                        Convertir
                      </button>
                    ) : (
                      <Link to={`/admin/dealers/${row.dealerId}/onboarding`}>Onboarding</Link>
                    )}
                    {" · "}
                    <select value={row.pipelineStage} onChange={(e) => changeStage(row.id, e.target.value)}>
                      {boardColumns.map((stage) => (
                        <option key={stage} value={stage}>
                          {PIPELINE_STAGE_LABELS[stage]}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ) : null}
      {!loading && view === "board" ? (
        <div className="admin-analytics-grid" style={{ overflowX: "auto" }}>
          {boardColumns.map((stage) => (
            <section key={stage} className="dealer-state-box" style={{ minWidth: 200 }}>
              <h4>{PIPELINE_STAGE_LABELS[stage]}</h4>
              {records
                .filter((r) => r.pipelineStage === stage)
                .map((row) => (
                  <div key={row.id} style={{ marginBottom: "0.75rem", padding: "0.5rem", border: "1px solid #ddd", borderRadius: 6 }}>
                    <strong>{row.businessName}</strong>
                    <p className="muted">{row.city}</p>
                    {row.dealerId ? (
                      <Link to={`/admin/dealers/${row.dealerId}`}>Abrir</Link>
                    ) : (
                      <button type="button" className="admin-link" onClick={() => convert(row.id)}>
                        Convertir
                      </button>
                    )}
                  </div>
                ))}
            </section>
          ))}
        </div>
      ) : null}
    </FoundingShell>
  );
}
